import { componentSelector } from 'wordpress/selectors'

import '../styles/Corporate.scss'

const partnersConfigurationSelector = componentSelector('partners')

export const Partner = ({ partners }) => {
    const getLink = children =>
        partners.buttonAction === 'page' ? (
            <Link className="btn btn-success" to={partners.page}>
                {children}
            </Link>
        ) : (
            <a className="btn btn-success" href={partners.url}>
                {children}
            </a>
        )

    return (
        <div className="partners container-fluid">
            <div className="inner-container">
                <Image className="img-container" image={partners.image} background />
                <div className="info-container">
                    <h2>{partners.title}</h2>
                    <div className="divider">
                        <hr />
                    </div>
                    <div className="text">{partners.content}</div>
                    {getLink(partners.buttonLabel)}
                </div>
            </div>
        </div>
    )
}

export const Partners = partners => (partners.enabled ? <Partner partners={partners} /> : null)

export default connect(partnersConfigurationSelector)(Partners)
